// 数据类接口
import { axios } from '@/utils/axios'
import Vue from 'vue'

const hash = '1603418883851'

// 获取航点数据
export async function flightcities () {
  const cityData = Vue.ls.get('FLIGHT_CITIES')

  if (cityData) {
    if (cityData.hash !== hash) {
      return getFlightCities()
    }

    return cityData.data
  } else {
    return getFlightCities()
  }
}

async function getFlightCities () {
  try {
    const { list = [] } = await axios({
      url: '/psg-community-user/api/information/flightcities',
      method: 'post',
      data: {}
    })

    if (list.length) {
      Vue.ls.set('FLIGHT_CITIES', {
        data: list,
        hash
      }, 7 * 24 * 60 * 60 * 1000)
    }

    return list
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取国家列表
export async function getCountry (valueName = 'countryCode') {
  try {
    const { data } = await axios({
      url: '/psg-community-user/api/utils/countryList',
      method: 'get',
      params: {}
    })

    const list = []
    data.forEach(item => {
      const country = {
        value: item[valueName],
        label: item.chineseName,
        id: item.id
      }

      if (country.id === 48) {
        country.isLeaf = false
        list.unshift(country)
      } else {
        list.push(country)
      }
    })

    return list
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取省份列表
export async function getProvince (value) {
  try {
    const { data } = await axios({
      url: '/psg-community-user/api/utils/stateList',
      method: 'get',
      params: {
        countryId: value
      }
    })

    return data.map(item => {
      return {
        value: item.id,
        label: item.chiNam,
        id: item.id,
        isLeaf: false
      }
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取城市列表
export async function getCity (value) {
  try {
    const { data } = await axios({
      url: '/psg-community-user/api/utils/cityList',
      method: 'get',
      params: {
        stateId: value
      }
    })

    return data.map(item => {
      return {
        value: item.id,
        label: item.chiName,
        id: item.id
      }
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
